import styled from "styled-components";

export const TinyMceStyle = styled.div`

.tox.tox-tinymce.tox-fullscreen {
    z-index: 200 !important;
}

`